import { render } from "./SectionHeading.vue?vue&type=template&id=950ed8f8&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import "./SectionHeading.vue?vue&type=style&index=0&id=950ed8f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jerald Pamugas\\OneDrive\\Desktop\\Projects\\jerald-pamugas-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950ed8f8"]])

export default __exports__